import { useAuthBootstrap } from '../../hooks/useAuthBootstrap';
import { env } from '../../config';

export function AuthInitializer() {
  // Skip authentication bootstrap if bypass mode is enabled
  if (!env.features.authBypass) {
    useAuthBootstrap();
  }
  
  // This component doesn't render anything
  return null;
}
